import React from 'react';
import { Routes, Route, NavLink, Navigate } from 'react-router-dom';
import TeamSection from '../components/equipos/TeamSection';
import { TEAMS_DATA } from '../data/teamsData';

const GameNav = () => (
  <div className="sticky top-24 z-40 mb-12">
    <div className="container mx-auto px-4">
      <div className="inline-flex gap-2 p-2 bg-brand-dark/95 backdrop-blur-sm rounded-xl border border-brand-white/10">
        {Object.keys(TEAMS_DATA).map((game, index) => (
          <React.Fragment key={game}>
            <NavLink
              to={`/equipos/${game.toLowerCase()}`}
              className={({ isActive }) =>
                `px-8 py-2 text-3xl font-morganite tracking-wider transition-all duration-300 ${
                  isActive 
                    ? 'text-brand-peach bg-brand-red/20' 
                    : 'text-brand-white/70 hover:text-brand-white hover:bg-brand-red/10'
                } rounded-lg`
              }
            >
              {game}
            </NavLink>
            {index < Object.keys(TEAMS_DATA).length - 1 && (
              <div className="w-px self-stretch bg-brand-red/20" />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  </div>
);

function Equipos() {
  return (
    <div className="relative min-h-screen pb-32">
      {/* Fondo fijo con gradiente */}
      <div className="fixed inset-0 -z-10 bg-gradient-to-b from-brand-dark via-brand-dark/95 to-brand-dark" />
      
      <GameNav />
      
      <Routes>
        <Route 
          path="/" 
          element={<Navigate to="/equipos/pubg" replace />} 
        />
        
        {Object.entries(TEAMS_DATA).map(([game, data]) => (
          <Route
            key={game}
            path={`/${game.toLowerCase()}`}
            element={
              <TeamSection
                roster={data.roster}
                staff={data.staff}
                backgroundImage={data.backgroundImage}
                pergaminoImage={data.pergaminoImage}
              />
            }
          />
        ))}
      </Routes>
    </div>
  );
}

export default Equipos;